import React from "react";

import { Link, Text, View } from "@react-pdf/renderer";
import { t } from "i18next";

import { dlPDFImageStyles } from "./ReactPDFStyling";
import { truncateTagTitle } from "./tagTitle";

interface AttachmentTagsProps {
  /** What the attachment shows: entity headings, or a legacy bulletin's tag titles. */
  labels: string[] | undefined;
  /** The gallery letter the entity list refers to this attachment by. */
  letter?: string;
  alertUrl: string;
  isVideo: boolean;
}

/** The pills shown under an attachment, and the link out for a video. */
const AttachmentTags: React.FC<AttachmentTagsProps> = ({
  labels,
  letter,
  alertUrl,
  isVideo,
}) => (
  <View style={dlPDFImageStyles.image_tags_container}>
    {letter && <Text style={dlPDFImageStyles.photo_letter}>{letter}</Text>}
    {labels?.map((label, index) => (
      <Text style={dlPDFImageStyles.tag} key={index.toString()}>
        {truncateTagTitle(label)}
      </Text>
    ))}
    {isVideo && (
      <Link style={dlPDFImageStyles.video_link} src={alertUrl}>
        {t("bulletin:pdf_view_video")}
      </Link>
    )}
  </View>
);

export default AttachmentTags;
